<template>
  <div id="News-Icon">
    <box-icon color="white" size="sm" name="news"></box-icon>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {

    }
  }
}
</script>

<style>

</style>
